import { AuthShell } from 'src/components/Layout';
import { ForgotPasswordContainer } from 'src/containers/Authentication';
import { usePageMeta } from 'src/hooks';

const ForgotPasswordPage = () => {
  usePageMeta('Forgot Password');

  return (
    <AuthShell>
      <ForgotPasswordContainer />
    </AuthShell>
  );
};

export default ForgotPasswordPage;
